import { useParams } from "react-router-dom"
import { useApiRead } from "source/shared/SessionApiResource"

export function useGroupType() {
  const { groupTypeSlug } = useParams()
  return useApiRead(`/groups/v2/group_types/${groupTypeSlug}`)
}
